import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {LevelService} from '../../shared/services/level/level.service';
import {StatesService} from '../../shared/services/state/states.service';
import {Subscription} from 'rxjs/index';
import {TranslateService} from '@ngx-translate/core';
import {AbstractMatTable} from '../../shared/classes/mat-table/abstract-mat-table';
import {CrudConstants} from '../../shared/constants/crud.constants';
import CRUD_MODE = CrudConstants.CRUD_MODE;


@Component({
  selector: 'app-level',
  templateUrl: './levels.component.html',
  styleUrls: ['./levels.component.css']
})
export class LevelsComponent extends AbstractMatTable implements OnInit, OnDestroy {

  readonly  CRUD_MODE = CRUD_MODE;
  public activeLevel: boolean = true;
  public reloadListLevel: Subscription;
  public levelSubscription: Subscription;

  constructor(private levelService: LevelService,
              public statesService: StatesService,
              private translate: TranslateService) {
    super();
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.getLevels();
    this.levelSubscription = this.statesService.stateLevelChangedSubject
      .subscribe(() => this.getLevels()
      );
    this.reloadListLevel = this.statesService.reloadListLevel
      .subscribe(() => this.getLevels()
      );
  }

  ngOnDestroy() {
    this.levelSubscription.unsubscribe();
    this.reloadListLevel.unsubscribe();
  }

  reLoadList() {
    this.activeLevel = !this.activeLevel;
    this.statesService.reloadListLevel.next();
  }

  getActiveTextForSlider() {
    let value: string = '';
    this.translate.get(this.activeLevel ? 'LEVEL_ACTIVE' : 'LEVEL_INACTIVE').subscribe((text: string) => {
      value = text;
    });
    return value;
  }

  private getLevels() {
    this.setMatTable(this.levelService.getLevels(this.activeLevel, this.statesService.stateLevel),
      ['id', 'parent', 'name', 'email', 'address', 'action']);
  }

}
